import { Menu } from 'lucide-react';
import { PropertySwitcher } from './PropertySwitcher';
import { NotificationBell } from './NotificationBell';
import { GlobalSearch } from './GlobalSearch';
import { Button } from '../shared';

interface HeaderProps {
  onMenuClick?: () => void;
  isMobile?: boolean;
}

export function Header({ onMenuClick, isMobile }: HeaderProps) {
  return (
    <header className="bg-white border-b border-surface-200 h-16 flex items-center justify-between px-4 md:px-6">
      <div className="flex items-center gap-3">
        {/* Mobile hamburger */}
        {isMobile && (
          <Button
            type="button"
            variant="ghost"
            onClick={onMenuClick}
            className="p-2 -ml-2 text-surface-600 hover:text-surface-900 hover:bg-surface-100"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </Button>
        )}

        {/* Property Switcher */}
        <div className="w-48 md:w-64">
          <PropertySwitcher />
        </div>
      </div>

      {/* Search — hidden on mobile */}
      <div className="hidden md:block flex-1 max-w-2xl mx-6">
        <GlobalSearch />
      </div>

      {/* Actions */}
      <div className="flex items-center space-x-4">
        <NotificationBell />
      </div>
    </header>
  );
}
